<template>
    <div :id="groupId + '-' + item.id" class="accordion-item" :class="[theme]">
        <dt class="header">
            <button @click="setActive(item.id)" class="trigger" v-bind:class="{ '-active': isActive }">
                <slot name="header" />
                <span class="icon-chevron-down trigger-icon" v-bind:class="{ '-active': isActive }"></span>
            </button>
        </dt>
        <transition
            name="accordion-item"
            @enter="startTransition"
            @after-enter="endTransition"
            @before-leave="startTransition"
            @after-leave="endTransition">
            <dd v-if="isActive" class="details">
                <div class="details-inner">
                    <slot name="content" />
                </div>
            </dd>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'totem-accordion-item',
        props: {
            item: Object,
            multiple: Boolean,
            groupId: String,
            theme: {
                type: String,
                validator: (prop) => ['header-menu', 'mobile-menu', 'order-history', 'organization-report', 'micro-learning-toc', 'micro-learning-overview'].includes(prop),
                default: 'basic'
            }
        },
        data () {
            return {
                isActive: false
            }
        },
        methods: {
            setActive (id) {
                this.isActive = !this.isActive
            },
            startTransition (el) {
                el.style.height = el.scrollHeight + 'px'
            },
            endTransition (el) {
                el.style.height = ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .trigger,
    .details-inner {
        padding: 0.75rem 1.25rem;
    }

    .accordion-item {
        &.header-menu {
            margin: 0 0 -1px;
            $size: 10px;
            border-bottom: 1px solid $orange;

            &:last-child {
                border: none;
            }

            .header {
                position: relative;
            }

            .trigger {
                font-size: 1.6rem;
                width: 100%;
                display: flex;
                justify-content: space-between;
                background: transparent;
                border: none;
                padding: 15px 75px 15px 15px;
                color: $black;
                white-space: nowrap;
            }

            .trigger-icon {
                color: $black;
                display: block;
                position: absolute;
                top: 0;
                right: 20px;
                bottom: 0;
                margin: auto;
                width: 0;
                height: 0;
                border-left:  $size solid transparent;
                border-right:  $size solid transparent;
                border-top:  $size solid $black;
                border-radius: 4px;
                transition: transform 0.2s ease;
                font-size: 2rem;
            }

            .details {
                overflow: hidden;
                background: transparent;
                margin: 0 15px;
            }

            .details-inner {
                padding: 0 10px;
                border: none;
            }
        }
        &.mobile-menu {
            margin: 0 0 -1px;
            $size: 10px;

            .header {
                position: relative;
            }

            .trigger {
                font-family: Nunito-Bold, sans-serif;
                font-size: 2rem;
                width: 100%;
                display: flex;
                justify-content: space-between;
                background: transparent;
                border: none;
                padding: 15px 50px 15px 0;
                color: $white;
            }

            .trigger-icon {
                color: $white;
                display: block;
                position: absolute;
                top: 0;
                right: 20px;
                bottom: 0;
                margin: auto;
                width: 0;
                height: 0;
                border-left:  $size solid transparent;
                border-right:  $size solid transparent;
                border-top:  $size solid $white;
                border-radius: 4px;
                transition: transform 0.2s ease;

                &.-active {
                    transform: translateY(calc($size / 4)) rotate(180deg);
                }
            }

            .details {
                overflow: hidden;
                background: transparent;
                margin: 0 15px;
            }

            .details-inner {
                padding: 0 10px;
                border: none;
            }
        }
        &.order-history {
            margin: 0 0 -1px;
            $size: 15px;

            .header {
                position: relative;
            }

            .trigger {
                width: 100%;
                display: flex;
                justify-content: space-between;
                background: $white;
                border: 1px solid $quill_gray;
                padding: 10px 50px 10px 0;
            }

            .trigger-icon {
                display: block;
                position: absolute;
                top: 0;
                right: 20px;
                bottom: 0;
                margin: auto;
                width: $size;
                height: $size;
                border-right: 2px solid $tundora;
                border-bottom: 2px solid $tundora;
                transition: transform 0.2s ease;

                
                &:before {
                    font-size: 2rem;
                }
            }

            .details {
                overflow: hidden;
                background: $white;
                margin: 0 15px;
            }

            .details-inner {
                padding: 20px;
                border: 1px solid $quill_gray;
                border-top: none;
            }
        }
        &.micro-learning-toc {
            margin: 0 0 -1px;
            $size: 15px;
            background-color: $white;
            color: $black;

            .header {
                position: relative;
                padding-top: 3px;
            }

            .trigger {
                cursor: pointer;
                width: 100%;
                display: flex;
                justify-content: space-between;
                border: 0;
                background: $white;
            }

            .trigger-icon {
                display: block;
                position: absolute;
                top: 0;
                left: 8px;
                color: $black;
                bottom: 0;
                margin: auto;
                width: 16px;
                height: 16px;
                transition: transform 0.2s ease;
                transform-origin: center;

                
                &:before {
                    font-size: 2rem;
                }

                &.-active  {
                    transform: scaleY(-1);
                }
            }

            .details {
                overflow: hidden;
                color: $white;
                margin: 0;
                [class*="mobile_sm"] & {
                    margin: 0;
                }
            }

            .details-inner {
                border-top: none;
                padding: 0;
            }
        }
        &.micro-learning-overview {
            margin: 0 0 -1px;
            $size: 15px;

            .header {
                position: relative;
                background-color: $heavy_metal;
            }

            .trigger {
                cursor: pointer;
                width: 100%;
                display: flex;
                justify-content: space-between;
                background-color: $bright_gray;
                border: 0;
                color: $black;
                font-family: Nunito-Bold, sans-serif;
                padding: 0 45px;
            }

            .trigger-icon {
                display: block;
                position: absolute;
                top: 5px;
                left: 45px;
                bottom: 0;
                margin: auto;
                width: 10px;
                height: 10px;
                border-right: 3px solid $black;
                border-bottom: 3px solid $black;
                transition: transform 0.2s ease;
                transform: translateY(calc(-1 * $size / 4)) rotate(-45deg);
                [class*="mobile_sm"] & {
                  width: 7px;
                  height: 7px;
                  top: 5px;
                  right: 7px;
                }

                &.-active  {
                    transform: translateY(calc(-1 * $size / 4)) rotate(45deg)
                }
            }

            .details {
                overflow: hidden;
                background-color: $wild_sand;
                color: $white;
                margin: 0;
                [class*="mobile_sm"] & {
                    margin: 0;
                }
            }

            .details-inner {
                border-top: none;
                padding: 0;
            }
        }
        &.organization-report {
            margin: 0 0 -1px;
            $size: 15px;

            .header {
                position: relative;
            }

            .trigger {
                cursor: pointer;
                width: 100%;
                display: flex;
                justify-content: space-between;
                background: $alabaster;
                border: 1px solid $quill_gray;
                padding: 10px 0 10px 0;

                &.-active  {
                    background-color: $champagne;
                    border: 1px solid $champagne;
                }
            }

            .trigger-icon {
                display: block;
                position: absolute;
                top: 0;
                right: 20px;
                bottom: 0;
                margin: auto;
                width: $size;
                height: $size;
                border-right: 2px solid $tundora;
                border-bottom: 2px solid $tundora;
                transition: transform 0.2s ease;
                transform: translateY(calc(-1 * $size / 4)) rotate(45deg);
                [class*="mobile_sm"] & {
                  width: 7px;
                  height: 7px;
                  top: 5px;
                  right: 7px;
                }

                &.-active  {
                    transform: translateY(calc($size / 4)) rotate(225deg)
                }
            }

            .details {
                overflow: hidden;
                background: $white;
                margin: 0;
                [class*="mobile_sm"] & {
                    margin: 0;
                }
            }

            .details-inner {
                padding: 20px;
                border: 1px solid $quill_gray;
                border-top: none;
            }
        }
    }

    .accordion-item-enter-active, .accordion-item-leave-active {
        will-change: height;
        transition: height 0.2s ease;
    }

    .accordion-item-enter, .accordion-item-leave-to {
        height: 0 !important;
    }
</style>
